import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import PrimeVue from "primevue/config";

import MainLayout from "./MainLayout.vue";
import DangKyPage from "./pages/DangKy.vue";
import CapNhatMinhChungPage from "./pages/CapNhatMinhChung.vue";
import TraCuuHoSoPage from "./pages/TraCuuHoSo.vue";
import TraCuuKetQuaPage from "./pages/TraCuuKetQua.vue";
import TraCuuKetQuaThongBaoPage from "./pages/TraCuuKetQuaThongBao.vue";
import GuideRegistration from "./pages/GuideRegistration.vue";
import TraCuuNhapHoc from "./pages/TraCuuNhapHoc.vue"

import "primevue/resources/themes/fluent-light/theme.css";
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import Tooltip from "primevue/tooltip";
const app = createApp(MainLayout);
app.config.errorHandler = (err, instance, info) => {
    // report error to tracking services
}
app.use(PrimeVue, {
    ripple: true,
    inputStyle: "outlined",
    locale: {
        accept: "Đồng ý",
        reject: "Hủy bỏ",
        dayNames: [
            "Chủ nhật",
            "Thứ 2",
            "Thứ 3",
            "Thứ 4",
            "Thứ 5",
            "Thứ 6",
            "Thứ 7",
        ],
        dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        monthNames: [
            "Tháng 1",
            "Tháng 2",
            "Tháng 3",
            "Tháng 4",
            "Tháng 5",
            "Tháng 6",
            "Tháng 7",
            "Tháng 8",
            "Tháng 9",
            "Tháng 10",
            "Tháng 11",
            "Tháng 12",
        ],
        monthNamesShort: [
            "Th1",
            "Th2",
            "Th3",
            "Th4",
            "Th5",
            "Th6",
            "Th7",
            "Th8",
            "Th9",
            "Th10",
            "Th11",
            "Th12",
        ],
        chooseYear: "Chọn năm",
        chooseMonth: "Chọn tháng",
        chooseDate: "Chọn ngày",
        prevDecade: "10 năm trước",
        nextDecade: "10 năm sau",
        prevYear: "Năm trước",
        nextYear: "Năm sau",
        prevMonth: "Tháng trước",
        nextMonth: "Tháng sau",
        prevHour: "Giờ trước",
        nextHour: "Giờ tới",
        prevMinute: "Phút trước",
        nextMinute: "Phút tới",
        prevSecond: "Giây trước",
        nextSecond: "Giây tới",
        am: "sáng",
        pm: "chiều",
        today: "Hôm nay",
        weekHeader: "Tuần",
        firstDayOfWeek: 1,
        dateFormat: "dd/mm/yy",
        weak: "Tuần",
        medium: "Trung bình",
        strong: "Mạnh",
        passwordPrompt: "Nhập mật khẩu",
        emptyFilterMessage: "Không tìm thấy bản ghi nào",
        searchMessage: "Có {0} kết quả tìm kiếm",
        selectionMessage: "{0} bản ghi được chọn",
    },
});

const routes = [
    { path: "/", component: DangKyPage },
    { name: "edit", path: "/cap-nhat-thong-tin/:token", component: DangKyPage },
    {
        name: "update-files",
        path: "/cap-nhat-minh-chung/:token",
        component: CapNhatMinhChungPage,
    },
    { 
        name: "tra-cuu", 
        path: "/tra-cuu/ho-so", 
        component: TraCuuHoSoPage,
        //redirect: '/tra-cuu/ket-qua'
     },
    // {
    //     name: "tra-cuu-ket-qua",
    //     path: "/tra-cuu/ket-qua",
    //     component: TraCuuKetQuaPage,
    // },
    {
        name: "tra-cuu-nhap-hoc",
        path: "/tra-cuu",
        component: TraCuuNhapHoc,
    },
    {
        name: "guide",
        path: "/guide",
        component: GuideRegistration,
        beforeEnter(to: any, from: any, next: any) {
            window.location.href = "https://tuyensinh.utc.edu.vn/?q=tin-tuyen-sinh/h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-%C4%91%C4%83ng-k%C3%BD-x%C3%A9t-tuy%E1%BB%83n-%C4%91%E1%BA%A1i-h%E1%BB%8Dc-ch%C3%ADnh-quy-online-b%E1%BA%B1ng-h%E1%BB%8Dc-b%E1%BA%A1-v%C3%A0-k%E1%BA%BFt-h%E1%BB%A3p";
        },
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
app.use(router);
app.directive("tooltip", Tooltip);
app.mount("#app");
